import { render, staticRenderFns } from "./Tick.vue?vue&type=template&id=3dc03872&scoped=true&"
import script from "./Tick.vue?vue&type=script&lang=js&"
export * from "./Tick.vue?vue&type=script&lang=js&"
import style0 from "./Tick.vue?vue&type=style&index=0&id=3dc03872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc03872",
  null
  
)

export default component.exports